import React from 'react';
import { Box } from 'components';

interface ButtonGroupProps {
  children: React.ReactNode | React.ReactNode[];
}

export const ButtonGroup = ({ children }: ButtonGroupProps) => {
  return (
    <Box
      sx={{
        position: 'absolute',
        display: 'flex',
        right: '1rem',
        bottom: '0.5rem',
      }}
    >
      {children}
    </Box>
  );
};
